import { render, staticRenderFns } from "./CompanyCertificatesFilter.vue?vue&type=template&id=1eb60d23&"
import script from "./CompanyCertificatesFilter.vue?vue&type=script&lang=js&"
export * from "./CompanyCertificatesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports